import { useEffect } from 'react';
import donationLandingStore from '../stores/DonationLandingStore';
import useSearchStore from 'stores/SearchStoreV2';

const useSearch = ({ matchId = null, forceMatch = false }) => {
  const searchStore = useSearchStore();

  useEffect(() => {
    searchStore.getTopics();
    searchStore.getCategories();
  }, []);

  useEffect(() => {
    if (forceMatch && (!matchId || !searchStore.topics.length)) return;

    searchStore.getCharities();
    if (donationLandingStore.topCauzes.length === 0) {
      donationLandingStore.getAssociatedEvents({ matchId });
    }
  }, [matchId, searchStore.topics]);
};

export default useSearch;
